/**
=========================================================
* Material Dashboard 2 PRO React TS - v1.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-2-pro-react-ts
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components

// Material Dashboard 2 PRO React TS components
import MDBox from "components/MDBox";

// Material Dashboard 2 PRO React TS examples components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";

import ModalComponent from "components/Modal";
import {
  Backdrop,
  Card,
  CardContent,
  CircularProgress,
  Grid,
} from "@mui/material";
import CotizacionPorId from "components/VistaModulos/CotizacionPorId";
import { useCotizacionProveedor } from "hooks/useCotizacionProveedor";

function CotizacionProveedor(): JSX.Element {
  const {
    intl,
    procesando,
    isAlertOpen,
    mensajeAlert,
    handleisAlertClose,
    cotizacion,
    page,
    rowsPerPage,
    idUsuario,
    detallesCotizacionPaginados,
    handleChangePage,
    handleChangeRowsPerPage,
    gestionarProducto,
    noDisponibleProducto,
    isAlertOpenPrecio,
    handleisAlertOpenPrecio,
    handleisAlertClosePrecio,
    procesandoPrecio,
    onTodosGestionados,
  } = useCotizacionProveedor();

  return (
    <DashboardLayout>
      <MDBox py={2}>
        <Card>
          <CardContent>
            <Grid
              container
              justifyContent="center"
              alignItems="center"
              sx={{ height: "100%", mt: 1 }}
            >
              <Grid xs={12}>
                <CotizacionPorId
                  verCotizacion={cotizacion}
                  procesando={procesando}
                  page={page}
                  rowsPerPage={rowsPerPage}
                  detallesCotizacionPaginados={detallesCotizacionPaginados}
                  handleChangePage={handleChangePage}
                  handleChangeRowsPerPage={handleChangeRowsPerPage}
                  gestionarProducto={gestionarProducto}
                  noDisponibleProducto={noDisponibleProducto}
                  handleisAlertOpenPrecio={handleisAlertOpenPrecio}
                  isAlertOpenPrecio={isAlertOpenPrecio}
                  handleisAlertClosePrecio={handleisAlertClosePrecio}
                  procesandoPrecio={procesandoPrecio}
                  onTodosGestionados={onTodosGestionados}
                />
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </MDBox>

      {/*<Footer />*/}
      <Backdrop
        sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })}
        open={procesando}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <ModalComponent handleClose={handleisAlertClose} isOpen={isAlertOpen} key={"alerta"}>
        <Grid container spacing={2} style={{ textAlign: "center" }}>
          <Grid item xs={12}>
            <br />
            <br />
            <p>{mensajeAlert}</p>
          </Grid>
        </Grid>
      </ModalComponent>
    </DashboardLayout>
  );
}

export default CotizacionProveedor;
